import { render, staticRenderFns } from "./InpatientEMR.vue?vue&type=template&id=e6570cee&scoped=true"
import script from "./InpatientEMR.vue?vue&type=script&lang=js"
export * from "./InpatientEMR.vue?vue&type=script&lang=js"
import style0 from "./InpatientEMR.vue?vue&type=style&index=0&id=e6570cee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6570cee",
  null
  
)

export default component.exports